module.exports = __webpack_public_path__ + "static/media/estimator.bb407f73.svg";